import React from "react";
import { Box, Grid, Stack, Typography, useScrollTrigger } from "@mui/material";

import DialogCreateBoard from "../../../dashboard/components/DialogCreateBoard";
import FilterArchive from "./FilterArchive";
import { useResponsive } from "../../../../hooks/useResponsive";
import filterIcon from "../../../../styles/svg/epic-icon.svg";
import GlobalSearch from "../../../../components/Search";
import DrawerGlobalComp from "../../../../components/Drawer";
import { CustomButton } from "../../../../components/Button/Button";
import { ViewWeekOutlinedIcon } from "../../../../utils/constants/icons";
import { useBoardManagementHeader } from "../hooks/useBoardManagementHeader";

function Header() {
  const isMobile = useResponsive("down", "md");
  const trigger = useScrollTrigger();
  const {
    searchValue,
    isCreateDialogOpen,
    isFilterDrawerOpen,
    handleSearchChange,
    openCreateDialog,
    closeCreateDialog,
    openFilterDrawer,
    setIsFilterDrawerOpen,
  } = useBoardManagementHeader();

  return (
    <>
      {isMobile ? (
        <Grid
          container
          xs={12}
          className="remove-container-width fixed-ui"
          sx={{ top: trigger ? "0px" : isMobile ? "51px" : "" }}
          justifyContent={"center"}
          boxShadow={" 0px 1px 7px rgba(0, 0, 0, 0.3)"}
          pb={"16px !important"}
          pt={trigger ? "24px !important" : "20px !important"}
          alignItems={"center"}
        >
          <Grid
            item
            xs={6}
            md={12}
            lg={3}
            className="d-flex align-items-center"
          >
            <Typography fontWeight={600}>Board Management</Typography>
          </Grid>
          <Grid item xs={6} md={7} lg={9}>
            <Stack direction="row" justifyContent="end">
              <img
                src={filterIcon}
                alt="filter"
                style={{ marginRight: "8px" }}
                onClick={openFilterDrawer}
              />
            </Stack>{" "}
          </Grid>
        </Grid>
      ) : (
        <div className="d-flex justify-content-space-between mb-4">
          <p className="admin-header-heading">Board Management</p>
          <div className="d-flex align-items-center ">
            <div className="d-flex align-items-center mr-2">
              <p className="mr-1 filter-heading">Filter by Status:</p>
              <FilterArchive />
            </div>
            <div className="mr-2">
              <GlobalSearch
                placeholder={"Search Board"}
                searchText={searchValue}
                handleChange={handleSearchChange}
              />
            </div>
            <div>
              <CustomButton
                onClick={openCreateDialog}
                className="theme-bg-color capitalize"
                variant="contained"
                startIcon={<ViewWeekOutlinedIcon />}
              >
                Create Board
              </CustomButton>
              {isCreateDialogOpen && (
                <DialogCreateBoard
                  open={isCreateDialogOpen}
                  handleClose={closeCreateDialog}
                />
              )}
            </div>
          </div>
        </div>
      )}
      {isFilterDrawerOpen && (
        <DrawerGlobalComp
          open={isFilterDrawerOpen}
          setOpen={setIsFilterDrawerOpen}
        >
          <Box p={1}>
            <div className="mt-2">
              <p className="filter-text">Filter by Status:</p>
              <div className="mt-2">
                <FilterArchive />
              </div>
            </div>
            <div className="mt-4">
              <GlobalSearch
                placeholder={"Search Board"}
                searchText={searchValue}
                handleChange={handleSearchChange}
              />
            </div>

            <div className="mt-4">
              <div className="mt-2 d-flex justify-content-end">
                <CustomButton
                  onClick={openCreateDialog}
                  className="theme-bg-color capitalize"
                  variant="contained"
                  startIcon={<ViewWeekOutlinedIcon />}
                >
                  Create Board
                </CustomButton>
                {isCreateDialogOpen && (
                  <DialogCreateBoard
                    open={isCreateDialogOpen}
                    handleClose={closeCreateDialog}
                  />
                )}
              </div>
            </div>
          </Box>
        </DrawerGlobalComp>
      )}
    </>
  );
}

export default React.memo(Header);
